import { Link } from 'react-router';

import { Label } from '@/components/ui/Label';
import { episodePath, type Episode } from '@/content/serie';

import { Thumb } from './Thumb';

/** Vignette d'épisode de la page série : publiée (lien) ou annoncée (sans lien). */
export function EpisodeCard({ episode }: { episode: Episode }) {
  const todo = episode.status !== 'publie';
  const content = (
    <>
      <Thumb num={episode.num} minutes={episode.videoMinutes} todo={todo} />
      <span
        className={
          todo
            ? 'text-h5 font-medium text-encre-mute'
            : 'text-h5 font-medium group-hover:underline group-hover:decoration-ciel group-hover:decoration-2 group-hover:underline-offset-4'
        }
      >
        {episode.title}
      </span>
      <Label>{todo ? `À venir, ${episode.planned ?? ''}` : episode.date}</Label>
    </>
  );

  return todo ? (
    <div className="flex flex-col gap-3">{content}</div>
  ) : (
    <Link to={episodePath(episode)} className="group flex flex-col gap-3 text-encre no-underline">
      {content}
    </Link>
  );
}
